import { Controller } from '@hotwired/stimulus';

// Drives the L1 -> L2 -> L3 cancellation-reason flow on the admin cancel
// screen. One reason target per L1 category; picking an L1 reveals its L2
// drivers, picking an L2 reveals that category's L3 probes (unless the L2 is
// marked data-skip-l3, e.g. pet loss). Submit stays disabled until the
// selection is complete; the server re-validates regardless.
export default class extends Controller {
  static targets = ['reason', 'submit'];

  connect() {
    this.refresh();
  }

  refresh() {
    const selectedL1 = this.element.querySelector(
      'input[name="subscription[cancellation_l1]"]:checked'
    )?.value;

    this.reasonTargets.forEach((block) => {
      const active = block.dataset.l1Code === selectedL1;

      const l2Group = block.querySelector('[data-cancellation-taxonomy-target~="l2Group"]');
      if (l2Group) {
        l2Group.hidden = !active;
        if (!active) {
          l2Group.querySelectorAll('input[type="radio"]').forEach((radio) => {
            radio.checked = false;
          });
        }
      }

      const otherGroup = block.querySelector('[data-cancellation-taxonomy-target~="otherGroup"]');
      if (otherGroup) {
        otherGroup.hidden = !active;
        if (!active) {
          otherGroup.querySelectorAll('input[type="text"], textarea').forEach((input) => {
            input.value = '';
          });
        }
      }

      const l3Group = block.querySelector('[data-cancellation-taxonomy-target~="l3Group"]');
      if (l3Group) {
        const checkedL2 = block.querySelector(
          'input[name="subscription[cancellation_l2]"]:checked'
        );
        const showL3 = active && !!checkedL2 && checkedL2.dataset.skipL3 !== 'true';
        l3Group.hidden = !showL3;
        if (!showL3) {
          l3Group.querySelectorAll('input[type="text"]').forEach((input) => {
            input.value = '';
          });
        }
      }
    });

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = !this.selectionComplete(selectedL1);
    }
  }

  selectionComplete(selectedL1) {
    if (!selectedL1) return false;

    const block = this.reasonTargets.find((b) => b.dataset.l1Code === selectedL1);
    if (!block) return false;

    const hasL2Options = block.querySelector('[data-cancellation-taxonomy-target~="l2Group"]');
    if (hasL2Options && !block.querySelector('input[name="subscription[cancellation_l2]"]:checked')) {
      return false;
    }

    const otherInput = block.querySelector('[data-cancellation-taxonomy-target~="otherInput"]');
    if (otherInput && otherInput.value.trim() === '') return false;

    return true;
  }
}
